import { inject } from '@angular/core';
import { Analytics, logEvent } from '@fido/firebase/analytics';
import { Auth, signOut } from '@fido/firebase/auth';
import { Router } from '@angular/router';
import { createInjectionToken } from 'ngxtension/create-injection-token';
import { CONFLICT_SEARCH_STORAGE_KEY } from '../../contacts/ui/conflict-search/conflict-search.constants';
import { PENDING_CREDENTIAL_KEY } from './pending-credential';

export const [injectSignOut, provideSignOut] = createInjectionToken(() => {
  const auth = inject(Auth);
  const router = inject(Router);
  const analytics = inject(Analytics);

  return async () => {
    logEvent(analytics, 'signing_out', { uid: auth.currentUser?.uid });
    await router.navigate([{ outlets: { primary: ['signing-out'], detail: null } }]);
    sessionStorage.removeItem(CONFLICT_SEARCH_STORAGE_KEY);
    localStorage.removeItem(PENDING_CREDENTIAL_KEY);
    await signOut(auth);
    await router.navigate([{ outlets: { primary: ['sign-in'], detail: null } }]);
  };
});
